/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Whats_NewInputs */

const fr_changelog_whats_new = /** @type {(inputs: Changelog_Whats_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quoi de neuf`)
};

/**

* @param {Changelog_Whats_NewInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const changelog_whats_new = /** @type {((inputs?: Changelog_Whats_NewInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Whats_NewInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_changelog_whats_new(inputs)
});